import { styled, keyframes, defaultTheme } from '@withjoy/joykit';

// Code taken from https://codepen.io/nikkunikku/pen/XWPKGqV and converted to Styled Components using ChatGPT

const colorParticle = defaultTheme.colors.brandPurple4;
const spacing = '2560px';
const time1 = '5s';
const time2 = '10s';
const time3 = '20s';
const time4 = '30s';

const generateParticles = (max: number) => {
  let val = '0px 0px ' + colorParticle;
  for (let i = 1; i <= max; i++) {
    val += `, ${Math.random() * parseInt(spacing)}px ${Math.random() * parseInt(spacing)}px ${colorParticle}`;
  }
  return val;
};

export const AnimationWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const Particle = styled.div`
  background: transparent;
`;

const ParticleAfter = styled.div`
  position: absolute;
  content: '';
  top: ${spacing};
`;

export const Particle1 = styled(Particle)`
  animation: ${keyframes`
    from { transform: translateY(0px); }
    to { transform: translateY(-${spacing}); }
  `} ${time1} linear infinite;
  box-shadow: ${generateParticles(600)};
  height: 1px;
  width: 1px;
  border-radius: 0.5px;
`;

export const Particle1After = styled(ParticleAfter)`
  box-shadow: ${generateParticles(600)};
  height: 1px;
  width: 1px;
  border-radius: 0.5px;
`;

export const Particle2 = styled(Particle)`
  animation: ${keyframes`
    from { transform: translateY(0px); }
    to { transform: translateY(-${spacing}); }
  `} ${time2} linear infinite;
  box-shadow: ${generateParticles(200)};
  height: 2px;
  width: 2px;
  border-radius: 1px;
`;

export const Particle2After = styled(ParticleAfter)`
  box-shadow: ${generateParticles(200)};
  height: 2px;
  width: 2px;
  border-radius: 1px;
`;

export const Particle3 = styled(Particle)`
  animation: ${keyframes`
    from { transform: translateY(0px); }
    to { transform: translateY(-${spacing}); }
  `} ${time3} linear infinite;
  box-shadow: ${generateParticles(100)};
  height: 3px;
  width: 3px;
  border-radius: 1.5px;
`;

export const Particle3After = styled(ParticleAfter)`
  box-shadow: ${generateParticles(100)};
  height: 3px;
  width: 3px;
  border-radius: 1.5px;
`;

export const Particle4 = styled(Particle)`
  animation: ${keyframes`
    from { transform: translateY(0px); }
    to { transform: translateY(-${spacing}); }
  `} ${time4} linear infinite;
  box-shadow: ${generateParticles(400)};
  height: 1px;
  width: 1px;
  border-radius: 0.5px;
`;

export const Particle4After = styled(ParticleAfter)`
  box-shadow: ${generateParticles(400)};
  height: 1px;
  width: 1px;
  border-radius: 0.5px;
`;
